export interface IProductEventNotification {
  eventHistoryId: string,
  eventUserId: string,
  eventTitle:string,
  eventType: string,
  productType: string,
  variantType: string,
  createdUserId:string
  createdOn: Date,
  createdUserFirstName: string,
  createdUserLastName:string
}

export class ProductEventNotification implements IProductEventNotification {
  eventHistoryId: string =  null;
  eventUserId: string =  null;
  eventTitle: string =  null;
  eventType: string =  null;
  productType: string =  null;
  variantType: string =  null;
  createdUserId: string =  null;
  createdOn: Date =  null;
  createdUserFirstName: string =  null;
  createdUserLastName: string =  null;
}
